<template>
  <div id="dashboard-analytics">
    <!-- Quick access  -->
    <vs-divider position="left"> 快捷入口 </vs-divider>
    <vs-row vs-type="flex">
      <vs-col
        vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="4" vs-sm="6" vs-xs="12">
        <vx-card
          title=""
          title-color="#fff"
          content-color="#fff"
          :card-background="'url(' + card_bg_img_1 + ')'"
          class="quick-item"
        >
          <h2 class="h-24 text-white text-center cursor-pointer" style="line-height: 6rem" @click="openCommunity">编程社区</h2>
        </vx-card>
      </vs-col>
      <vs-col
        vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="4" vs-sm="6" vs-xs="12">
        <vx-card
          title=""
          title-color="#fff"
          content-color="#fff"
          :card-background="'url(' + card_bg_img_2 + ')'"
          class="quick-item"
        >
          <h2 class="text-white cursor-pointer" style="line-height: 6rem" @click="openMatchCenter">赛事中心</h2>
        </vx-card>
      </vs-col>
    </vs-row>

    <vs-divider position="left"> 其他信息 </vs-divider>

    <vs-row vs-type="flex">
      <vs-col v-if="$acl.check('teacher')" vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-lg="6" vs-sm="6" vs-xs="12" class="quick-item">
        <vs-row vs-type="flex">
          <vx-card class="overflow-hidden">
            <h3>学校信息栏</h3>
            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
              <div class="card-content-wrap-1">
                <p>总教师数</p>
                <p class="num-content"> {{ staticData.teacher_num }} </p>
              </div>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
              <div class="card-content-wrap-1">
                <p>总班级数</p>
                <p class="num-content"> {{ staticData.class_num }} </p>
              </div>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
              <div class="card-content-wrap-1">
                <p>总学生数</p>
                <p class="num-content"> {{ staticData.student_num }} </p>
              </div>
            </vs-col>
            <!-- <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="4" vs-sm="6" vs-xs="12">
              <div class="card-content-wrap-1">
                <p>作品数</p>
                <p class="num-content"> {{ staticData.work_num }} </p>
              </div>
            </vs-col> -->
          </vx-card>
        </vs-row>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-lg="6" vs-sm="6" vs-xs="12" class="quick-item">
        <vs-row vs-type="flex">
          <vx-card class="overflow-hidden">
            <h3>创作工具</h3>
            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
              <div class="card-content-wrap">
                <img class="card-img" src="@/assets/images/haimakid/scratch.png" alt="" @click="openScratchEdit">
                <p>HAAI编辑器</p>
              </div>
            </vs-col>
            <!-- <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
              <div class="card-content-wrap">
                <img class="card-img" src="@/assets/images/haimakid/scratch.png" alt="">
                <p>HAAI编辑器</p>
              </div>
            </vs-col> -->
            <vs-button class="card-btn" color="warning" size="small" type="filled" @click="openCreativeToolPage">查看更多工具</vs-button>
          </vx-card>
        </vs-row>
      </vs-col>
      
    </vs-row>
  </div>
</template>

<script>
import { homeStatistics } from '@/api/school'
export default {
  components: {
  },
  data() {
    return {
      user: {},
      card_bg_img_1: require('@/assets/images/haimakid/das-c-1.jpg'),
      card_bg_img_2: require('@/assets/images/haimakid/das-c-2.jpg'),
      staticData: {
        teacher_num: 0,
        class_num: 0,
        student_num: 0,
        work_num: 0
      }
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem('userInfo'));
    if (this.$acl.get[0] != 'student') {
      this.statistics()
    }
  },
  computed: {},
  methods: {
    openCommunity() {
      window.open("https://shequ.haai.net/", "community");
    },
    openMatchCenter(){
      window.open("https://matchs.haai.net/", "matchCenter");
    },
    openCreativeToolPage() {
      this.$router.push({path: '/creativeTools'});
    },
    openScratchEdit() {
      window.open("https://shequ.haai.net/scratch/", "scratch");
    },
    statistics() {
      homeStatistics({}).then(res => {
        if (res.code == 1) {
          this.staticData = res.data
        }
      })
    }
  }
}
</script>

<style lang="scss">
#dashboard-analytics {
  .quick-item{
    margin-bottom: 10px;
  }
  .vx-card__body{
    text-align: center;
    position: relative;
    .card-right{
      position: absolute;
      top: 0;
      right: 10px;
      height: 100px;
    }
  }
  .card-content-wrap{
    width: 100%;
    display: inline-block;
    // text-align: center;
    padding: 0.5rem;
    .card-img{
      margin: 10px auto;
      width: 100%;
      max-width: 180px;
      cursor: pointer;
    }
  }
  .card-content-wrap-1{
    width: 100%;
    border: 1px solid #eee;
    margin: 1rem 0;
    padding: 1.4rem 1rem;
    border-radius: 20px;
    .num-content{
      font-size: 2rem;
    }
  }
  .width-50{
    width: 50%;
    display: inline-block;
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
